module.exports = __webpack_public_path__ + "img/ccf-ko-KR.168d2bc5.png";